import { api } from './client';
import type { AuthUser } from '../lib/auth';

export const authApi = {
  staff: () => api.get<AuthUser[]>('/api/v1/auth/staff').then(r => r.data),
  changeMyPassword: (current_password: string, new_password: string) =>
    api.post<{ ok: boolean }>('/api/v1/auth/me/password',
      { current_password, new_password }).then(r => r.data),
  setStaffPassword: (userId: string, new_password: string) =>
    api.post<{ ok: boolean }>(`/api/v1/auth/staff/${userId}/set-password`,
      { new_password }).then(r => r.data),
};
